<vectronic-card [title]="'Filter'">
  <div body class="schedule-template-filter">
    <vectronic-input-filter-with-header
      [title]="'Template Name'"
      [filterValue]="searchFilter().templateName"
      (filterValueChange)="onTemplateNameChange($event)"
      [stringToFilterConverter]="InputFilterWithHeaderComponent.stringToStringFilterConverter"
    ></vectronic-input-filter-with-header>

    <vectronic-selection-filter-with-header
      [title]="'Schedule Type'"
      [availableFilterItems]="availableScheduleTypes"
      [selectedItem]="searchFilter().scheduleType"
      (selectedItemChange)="onScheduleTypeChange($event)"
    ></vectronic-selection-filter-with-header>

    <vectronic-chips-filter-with-header
      [title]="'User Account'"
      [availableFilterItems]="availableUserAccounts()"
      [selectedItems]="searchFilter().userIds"
      (selectedItemsChange)="onUserIdsChange($event)"
    ></vectronic-chips-filter-with-header>
  </div>
</vectronic-card>
